













import Vue from "vue";
import Component from "vue-class-component";
import { codemirror } from "vue-codemirror";

// language js
import "codemirror/mode/javascript/javascript.js";
import "codemirror/addon/display/autorefresh.js";
// theme css
import "codemirror/theme/3024-night.css";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    codemirror
  }
})
export default class CodeEditor extends Vue {
  @Prop() value: any;

  private code: any;


  cmOptions: object = {
    // codemirror options
    tabSize: 6,
    mode: {
      name: "javascript",
      json: true,
      mime: "text/javascript"
    },
    theme: "3024-night",
    lineNumbers: true,
    line: true,
    readOnly: true,
    autoRefresh:true,
    autofocus:true,
  };

  constructor() {
    super();
    this.code = this.value;
  }

  get codeFormatted() {
    return JSON.stringify(this.code, null, 2);
  }

  onCmReady(cm) {
    //console.log("the editor is readied!", cm);
    //this.codemirror.save();
  }

  onCmFocus(cm) {
    //console.log("the editor is focus!", cm);
  }
}
